import React from 'react';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import { getStudentResultByMeasureYearGradePeriod } from '../../../utils/shared/filterUtils';
import { benchmarkSorting } from '../../../utils/shared/sortUtils';
import { PERIOD } from '../../../constants/shared/CommonConstants';
import { MEASURE, MEASURES } from '../../../constants/reading/MeasuresConstants';
import { isMeasureEnabledForSpecificMapper } from '../../../utils/shared/tableUtils';
import { SkillHeaderCell } from '../../cell/shared/Cells';
import { getD8InterpSortIndex, getD8ScoreSortIndex } from '../../../utils/reading/sortUtils';
import { columnsWithBorder } from '../shared/resultsHelper';
import { getGoalReading } from '../../../utils/reading/cellUtils';
import { getGoalText } from '../../../utils/shared/cellUtils';
import { GRADE } from '../../../constants/shared/GradesConstants';

const MAX_NUMBER_OF_CHARS_IN_ONE_ROW = 20;
const { OVERALL } = MEASURE;

const { SUMMARY } = PERIOD;
const { MAZE, LEXILE } = MEASURE;

export const getStudentColumns = (
    tableMeasures,
    selectedPeriod,
    statuses,
    year,
    grade,
    interps,
    isLexileShown,
    gradeToMeasureMapper,
    isDTC = false,
) =>
    tableMeasures.map(({ key, name, period }) => {
        const columnPeriod = selectedPeriod === SUMMARY ? period : selectedPeriod;
        const status = getStudentResultByMeasureYearGradePeriod(
            statuses,
            key,
            year,
            null,
            columnPeriod,
        );

        const isMeasureAvailable = isMeasureEnabledForSpecificMapper(
            key,
            grade,
            columnPeriod,
            gradeToMeasureMapper,
        );

        const goalSection = getGoalText(
            getGoalReading(isMeasureAvailable, interps, key, grade, columnPeriod),
        );

        const isResetButtonAvailable =
            isDTC &&
            selectedPeriod === PERIOD.SUMMER &&
            key === MEASURE.OVERALL &&
            grade === GRADE.THIRD_GRADE &&
            status &&
            status.score &&
            status.attemptNumber === 2;

        return {
            key,
            period: columnPeriod,
            isCellDisabled: !isMeasureAvailable,
            name,
            goalSection,
            status,
            isLexileShown,
            sortIndex: {
                interpSortIndex: getD8InterpSortIndex(key, status, isMeasureAvailable),
                scoreSortIndex: getD8ScoreSortIndex(key, status),
            },
            isInputCell: get(status, 'isWebEntry', false) || (!status && isEqual(key, MAZE)),
            isResetButtonAvailable,
        };
    });

export const compareFunction = column => (firstRow, secondRow) =>
    benchmarkSorting(
        Object.keys(firstRow)[column],
        Object.values(firstRow)[column].props.sortIndex,
        Object.values(secondRow)[column].props.sortIndex,
        firstRow.name.props,
        secondRow.name.props,
        MEASURES,
    );

export const mapSkillNamesToRowObject = (
    columns,
    columnsGroups,
    isLexileShown,
    isResetButtonAvailable = false,
) => {
    const skillNamesRowObject = {};
    columns.forEach(column => {
        switch (column.key) {
            case OVERALL:
                skillNamesRowObject[OVERALL] = (
                    <SkillHeaderCell
                        containerClassNames={`header-skill-cell-container 
                        ${isResetButtonAvailable && 'with-reset-button'}`}
                        classNames={`header-skill-twisted-cell empty ${
                            isLexileShown && 'hide-border'
                        }`}
                    />
                );
                break;
            case LEXILE:
                skillNamesRowObject[LEXILE] = (
                    <SkillHeaderCell
                        containerClassNames="header-skill-cell-container"
                        classNames="header-skill-twisted-cell empty"
                    />
                );
                break;
            default:
                skillNamesRowObject[column.key] = (
                    <SkillHeaderCell
                        label={column.title}
                        containerClassNames="header-skill-cell-container"
                        classNames={`header-skill-twisted-cell header-skill-cell-font ${
                            columnsWithBorder(columns, columnsGroups).includes(column.key)
                                ? 'grey-bottom-border'
                                : ''
                        } ${
                            column.title.length > MAX_NUMBER_OF_CHARS_IN_ONE_ROW
                                ? ' double-string'
                                : ''
                        } 
                                `}
                    />
                );
        }
    });

    return skillNamesRowObject;
};
